module.exports = __webpack_public_path__ + "img/empty-cart.add5f59.png";